// ** React Imports
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ** Third Party Components
import loadable from "@loadable/component";

// ** Custom Components
import Block from "components/layout/Block";

// ** Users Components
import ResultsDescription from "../ResultsDescription";

// ** Lazy Imports
const RankingFilters = loadable(() => import("../RankingFilters"), {
	ssr: false,
});

// #####################################################

const FiltersSection = ({ filtersOpen, setFiltersOpen }) => {
	const location = useLocation();
	const { state = {} } = location || {};
	const closeFiltersAfterLinkClick = state
		? state.closeFiltersAfterLinkClick
		: false;

	useEffect(() => {
		if (closeFiltersAfterLinkClick) {
			setFiltersOpen(false);
			location.state.closeFiltersAfterLinkClick = false;
		}
	}, [closeFiltersAfterLinkClick]);

	// #####################################################

	return (
		<Block flex column>
			<ResultsDescription
				filtersOpen={filtersOpen}
				setFiltersOpen={setFiltersOpen}
			/>

			{filtersOpen && <RankingFilters setFiltersOpen={setFiltersOpen} />}
		</Block>
	);
};

// #####################################################

export default FiltersSection;

// #####################################################
